/**
 * Four-step "Slik jobber vi" process section from Airon.html design.
 */
const DEFAULT_STEPS = [
  {
    num: "TRINN 01",
    title: "Befaring",
    body: "Vi kommer ut, måler og lytter. Du får en ærlig vurdering av hva som faktisk trengs — ikke mer.",
  },
  {
    num: "TRINN 02",
    title: "Prosjektering",
    body: "Tegninger, varmegjenvinning og aggregatvalg tilpasset bygget. Fast pris, ingen overraskelser.",
  },
  {
    num: "TRINN 03",
    title: "Installasjon",
    body: "Egne fagfolk på jobben.",
  },
  {
    num: "TRINN 04",
    title: "Service",
    body: "Overlevering med dokumentasjon. Serviceavtale om ønskelig — så varer anlegget i 20+ år.",
  },
];

export function ProcessSteps({
  tag = "04 / Slik jobber vi",
  heading = "Fra første befaring til siste filter.",
  timeline = "Typisk: 2–8 uker",
  steps = DEFAULT_STEPS,
  tint = true,
}) {
  return (
    <section className={`sec${tint ? " tint" : ""}`} id="prosess">
      <div className="wrap">
        <div className="sec-head">
          <div className="sec-tag">{tag}</div>
          <h2>{heading}</h2>
          {timeline ? (
            <span
              className="sec-tag"
              style={{ color: "var(--muted)", textAlign: "right" }}
            >
              {timeline}
            </span>
          ) : <span />}
        </div>
        <div className="process-grid">
          {steps.map((step) => (
            <div className="step" key={step.title}>
              <span className="num">{step.num}</span>
              <h4>{step.title}</h4>
              <p>{step.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ProcessSteps;
